<ll-titulo>Establecimientos</ll-titulo>
<ll-toolnavbar>
    <establecimiento-toolnavbar [displayButtons]="displayButtons"></establecimiento-toolnavbar>
</ll-toolnavbar>

<establecimientos [lugarTipo]="lugarTipo"></establecimientos>
